import { Dialog } from "@mui/material";
import React, { useState, useEffect } from "react";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import BasicSelect from "../Task/BasicSelect";
import Button from "../UniversalComponents/DefaultButton";
import CrossIcon from "../../assets/images/CrossIconGroupBy.svg";
import { useAddFieldsInManageListMutation } from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { pushAlert } from "../../utils/alertSlice";
import useRequireAuth from "../../utils/useRequireAuth";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/VectorX.svg";

const AddColumn = ({ tableData, open, closePopup, handleRowClick, editColumnData }) => {
  const { token } = useRequireAuth();
  const dispatch = useDispatch();

  const Types = [
    { label: "Text", value: "text" },
    { label: "Number", value: "number" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    type: "",
  });

  useEffect(() => {
    if (editColumnData) {
      setFormData({
        name: editColumnData.name || "",
        type: editColumnData.type || "",
      });
    }
  }, [editColumnData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      type: value,
    }));
  };

  const [
    postNewField,
    {
      data: addFieldResponseData,
      isError: addFieldError,
      isSuccess: addFieldSuccess,
      isLoading: addFieldLoading,
      error: addFieldErrorResponse,
    },
  ] = useAddFieldsInManageListMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const tableId = tableData?.id;
    const payload = {
      field_label: formData.name.trim(),
      data_type: formData.type,
    };
    postNewField({ token, payload, tableId });
  };

  useEffect(() => {
    if (addFieldLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (addFieldSuccess) {
      dispatch(
        pushAlert({
          message: addFieldResponseData.message,
          type: "success",
          visible: true,
        })
      );
      if (addFieldResponseData?.status) {
        console.log("addFieldResponseData", addFieldResponseData?.status);
        closePopup();
        handleRowClick(tableData);
      }
    }
    // catch block
    if (addFieldError) {
      dispatch(pushAlert({ message: addFieldErrorResponse?.data?.message, type: "danger", visible: true }));
    }
  }, [addFieldSuccess, addFieldError, addFieldLoading]);

  return (
    <Dialog open={open} fullWidth>
      <div className="relative mt-18 bg-white h-full w-full flex flex-col font-popns   rounded-[10px] overflow-hidden no-scrollbar">
        <div className="mx-6 flex items-center justify-between py-4 md:py-3 border-BECBD3 rounded-t">
          <h3 className="text-16 text-1D4469 font-500">{editColumnData ? "Edit Column" : "Add Column"}</h3>
          <button
            onClick={closePopup}
            type="button"
            className="text-454545 hover:text-[#1D4469] text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
            aria-label="Close modal"
          >
            {/* <img src={CrossIcon} alt="Close" className="hover:bg-[#EBF2F6] w-5 h-5" /> */}
            <DeleteIcon />
          </button>
        </div>

        <form
          className="w-full grow min-h-0 pt-3 border-t flex flex-col justify-between p-4 gap-2"
          onSubmit={handleSubmit}
          noValidate
        >
          {/* Type Field */}
          <div className="w-full">
            <LabelComponent htmlFor="type" labelText="Type" size="small" />
            <BasicSelect
              options={Types}
              name="type"
              id="type"
              value={formData?.type}
              selectedOptions={Types.filter((option) => option.value === formData?.type)}
              onChange={handleSelectChange}
              type="select"
              size="medium"
              label="Type"
            />
          </div>

          {/* Name Field */}
          <div className="w-full">
            <LabelComponent htmlFor="name" labelText="List Name" size="small" />
            <InputComponent
              type="text"
              id="name"
              name="name"
              placeholder="Enter Name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          {/* Buttons */}
          <div className="flex gap-3 py-2 justify-end w-full">
            <Button variant="secondary" onClick={closePopup}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {editColumnData ? "Update" : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default AddColumn;
